import { OptionsObject } from 'notistack';

const opts: OptionsObject = {
  autoHideDuration: 3000,
  preventDuplicate: true,
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
};

export default opts;
